export function fmtKPINumber(
  n: number,
  options?: {
    decimals?: number;
    onlyLargerThan?: number;
    prefix?: string;
    suffix?: string;
    enableSymbols?: boolean;
  }
) {
  const {
    decimals = 1,
    onlyLargerThan = 0,
    enableSymbols = false,
    suffix = "",
  } = options ?? {};
  const isLg = n > onlyLargerThan && enableSymbols;
  const s = options?.prefix;
  let res = `${s ? s + " " : ""}${n.toFixed(decimals).replace(".", ",")}`;
  if (n === 0 || !n) {
    res = `${s ? s + " " : ""}0`;
  }

  if (isLg && n >= 1000000000000) {
    res = `${s ? s + " " : ""}${(n / 1000000000000).toFixed(
      decimals
    )}T`.replace(".", ",");
  }
  if (isLg && n >= 1000000000) {
    res = `${s ? s + " " : ""}${(n / 1000000000).toFixed(decimals)}B`.replace(
      ".",
      ","
    );
  }
  if (isLg && n >= 1000000) {
    res = `${s ? s + " " : ""}${(n / 1000000).toFixed(decimals)}M`.replace(
      ".",
      ","
    );
  }
  if (isLg && n >= 1000) {
    res = `${s ? s + " " : ""}${(n / 1000).toFixed(decimals)}K`.replace(
      ".",
      ","
    );
  }
  return insertDots(res) + "" + suffix;
}

function insertDots(val: string) {
  let counter = 0;
  let result = "";
  for (let i = val.length - 1; i >= 0; i--) {
    const char = val[i];
    if (!!char.match(/\d/)) {
      counter += 1;
    } else {
      counter = 0;
    }
    if (counter > 3) {
      counter = 1;
      result = "." + result;
    }
    result = char + result;
  }
  return result;
}
